import type { SchemaOf } from '../helpers';
import { objectSchemaOf, Joi } from '../helpers';
import type { Role } from './roles';

export interface IVerifyParams {
  token: string;
  allow: Role[];
}

const paramsSchemaMap: SchemaOf<IVerifyParams> = {
  token: Joi.string().required(),
  allow: Joi.array().items(Joi.string()).min(1).required(),
};

export const verifyParamsSchema = objectSchemaOf<IVerifyParams>(
  paramsSchemaMap
);

export interface IVerifyResult {
  status: number;
  message: string;
}
